import apiClient from '@/plugins/apiClient'
let basePath = "/pages";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: {},
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
     },
     mutations:{
        error(state, err) {
            state.single = null;
            state.errors = err

            if(err.response){
               state.errors.message = err.response.data
               state.errors.status = err.response.status;
               if( err.response.data.message ){
                   state.errors.message = err.response.data.message 
               }
            }
        },
        setList(state, resp) {
            state.list = resp.data
        },
        setMeta(state, resp){
          state.meta = resp.meta
        },
        setFilters(state, resp){
          state.filters = resp.filters
        },
        setSingle(state, resp){
               state.single = resp.data
               state.errors = {}
               state.message = {}
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    let params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getListLight({commit, state}, data){
               return new Promise((resolve, reject) => {
                    let params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'/light?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+data.slug).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp.data);
                     })
                     .catch(err => {
                         console.info('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          setMeta({commit}, data){
               commit('setMeta',{meta:data});
               // commit('success', true);
          },
          setFilters({commit}, data){
               commit('setFilters',{filters:data});
          }
     },
}